import React from 'react';
import PropTypes from 'prop-types';
import CustomOrderDocument from '../../../../documents/customOrderDocument';
import { Modal } from '@ami/react/core';
import { withRouter } from 'react-router-dom';
import { OrderView } from '../../../../orders/order';
import { appConfig } from '@ami/react/core';
import OrderDocumentsListComponent from './OrderDocumentsListComponent';
import AddCustomDocumentModalComponent from './AddCustomDocumentModalComponent';
import AddSharedDocumentModalComponent from './AddSharedDocumentModalComponent';
import { isAmiUserAuthorizedToManageOrderDocuments } from '../../../../authorization/amiPermissions';
import { AmiTaskDocument } from '../../../../ami-tasks/amiTaskDocument';
import CustomerApprovalDocument from '../../../../customer-approvals/customerApprovalDocument';

const DeleteDocumentConfirmationModal = ({
  show,
  onShowUpdated,
  onConfirm,
  document,
}) => (
  <Modal
    title="Remove document"
    show={show}
    onShowUpdated={onShowUpdated}
    okTitle="Yes"
    cancelTitle="No"
    onOk={onConfirm}
    showCancel={true}
  >
    <p>
      Are you sure you want to remove the document "
      <strong>{document ? document.name : null}</strong>"?
    </p>
  </Modal>
);

class OrderDocumentsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documentIdToRemove: null,
      showAddCustomDocumentModal: false,
      showAddSharedDocumentModal: false,
      documentIdDownloading: null,
    };

    this.downloadDocument = this.downloadDocument.bind(this);

    this.handleShowAddCustomDocumentModal =
      this.handleShowAddCustomDocumentModal.bind(this);
    this.handleHideAddCustomDocumentModal =
      this.handleHideAddCustomDocumentModal.bind(this);

    this.handleShowAddSharedDocumentModal =
      this.handleShowAddSharedDocumentModal.bind(this);
    this.handleHideAddSharedDocumentModal =
      this.handleHideAddSharedDocumentModal.bind(this);
  }

  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onDocumentsUpdated: PropTypes.func.isRequired,
  };

  handleShowAddCustomDocumentModal() {
    this.setState({ showAddCustomDocumentModal: true });
  }

  handleHideAddCustomDocumentModal() {
    this.setState({ showAddCustomDocumentModal: false });
  }

  handleShowAddSharedDocumentModal() {
    this.setState({ showAddSharedDocumentModal: true });
  }

  handleHideAddSharedDocumentModal() {
    this.setState({ showAddSharedDocumentModal: false });
  }

  downloadDocument(orderId, document) {
    this.setState({ documentIdDownloading: document.id });
    if (document.type === 'Shared') {
      CustomOrderDocument.getDownloadSharedUrl(orderId, document.id)
        .then((response) => (window.location = response.url))
        .catch(() => {})
        .finally(() => this.setState({ documentIdDownloading: null }));
    }
    if (document.type === 'Custom') {
      CustomOrderDocument.getDownloadUrl(orderId, document.id)
        .then((response) => (window.location = response.url))
        .catch(() => {})
        .finally(() => this.setState({ documentIdDownloading: null }));
    }
    if (document.type === 'AmiTask') {
      AmiTaskDocument.getDownloadUrl(document.relatedId, document.id)
        .then((response) => (window.location = response.url))
        .catch(() => {})
        .finally(() => this.setState({ documentIdDownloading: null }));
    }
    if (document.type === 'CustomerApproval') {
      CustomerApprovalDocument.getDownloadUrl(
        document.relatedId,
        document.id,
        true
      )
        .then((response) => (window.location = response.url))
        .catch(() => {})
        .finally(() => this.setState({ documentIdDownloading: null }));
    }
  }

  removeDocument = async () => {
    const document = this.props.order.documents.find(
      (x) => x.id === this.state.documentIdToRemove
    );
    if (document.type === 'Shared') {
      await CustomOrderDocument.deleteShared(
        this.props.order.id,
        this.state.documentIdToRemove
      );
    } else {
      await CustomOrderDocument.delete(
        this.props.order.id,
        this.state.documentIdToRemove
      );
    }
    this.setState({ documentIdToRemove: null });
    this.props.onDocumentsUpdated();
  };

  render() {
    const { order } = this.props;
    const canAddOrDelete =
      appConfig.isManagementApp &&
      order.status !== 'Cancelled' &&
      isAmiUserAuthorizedToManageOrderDocuments();

    return (
      <React.Fragment>
        <OrderDocumentsListComponent
          order={order}
          canAddOrDelete={canAddOrDelete}
          onAddDocumentButtonClicked={this.handleShowAddCustomDocumentModal}
          onAddSharedDocumentButtonClicked={
            this.handleShowAddSharedDocumentModal
          }
          markDocumentToRemove={(id) =>
            this.setState({ documentIdToRemove: id })
          }
          downloadDocument={this.downloadDocument}
          documentIdDownloading={this.state.documentIdDownloading}
        />
        {canAddOrDelete && (
          <React.Fragment>
            <DeleteDocumentConfirmationModal
              show={this.state.documentIdToRemove !== null}
              document={order.documents.find(
                (x) => x.id === this.state.documentIdToRemove
              )}
              onShowUpdated={(show) => {
                if (!show) this.setState({ documentIdToRemove: null });
              }}
              onConfirm={this.removeDocument}
            />
            <AddCustomDocumentModalComponent
              order={order}
              onDocumentCreated={this.props.onDocumentsUpdated}
              showModal={this.state.showAddCustomDocumentModal}
              hideModal={this.handleHideAddCustomDocumentModal}
            />
            <AddSharedDocumentModalComponent
              order={order}
              onDocumentCreated={this.props.onDocumentsUpdated}
              showModal={this.state.showAddSharedDocumentModal}
              hideModal={this.handleHideAddSharedDocumentModal}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(OrderDocumentsContainer);
